import type { MetricsResponse } from "@shared/types";
import { TileCard } from "./TileCard";
import { formatInteger, formatPaiseAsRupees } from "@/lib/format";

interface OrdersTileProps {
  orders: MetricsResponse["orders"];
}

export function OrdersTile({ orders }: OrdersTileProps) {
  const { count, revenueMinor } = orders;

  return (
    <TileCard label="Orders attributed" testId="tile-orders">
      <div className="tile-number" data-testid="orders-count">
        {formatInteger(count)}
      </div>
      <div className="tile-subline" data-testid="orders-revenue">
        {formatPaiseAsRupees(revenueMinor)}
      </div>
    </TileCard>
  );
}
